import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Home = () => {
  return (
    <Layout>
      <div className="hero-modern">
        <div className="container">
          <div className="hero-content-modern">
            <h1 className="hero-title-modern">
              AI Engineering for an Complex World
            </h1>
            <p className="hero-subtitle-modern">
              
            </p>
            <div className="hero-cta">
              <Link to="/about" className="btn-primary-modern">
                About
              </Link>
              <Link to="/visualizations" className="btn-secondary-modern">
                Projects
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="features-section">
        <div className="container">
          <div className="features-grid">
            <Link to="/about" className="feature-card feature-card-global">
              <h3>The Medium is the Message</h3>
              <p>LLMs aren't just tools—they're media that restructure information and the ways in which we interact with narratives. The systems I build account for this media ecology perspective, inspired by my graduate research into the political economy of information conducted at Rijksuniversiteit Groningen and the University of Michigan.</p>
            </Link>

            <Link to="/visualizations" className="feature-card feature-card-ai">
              <h3>Production Engineering</h3>
              <p>With extensive experience building ML and AI pipelines for Fortune 500 companies and robust technical training from Michigan's School of Information, I build systems that ship, not prototypes that demo. </p>
            </Link>

            <Link to="/photography" className="feature-card feature-card-photo">
              <h3>Visualization & Photography</h3>
              <p>We live in a world of visuality, and my passion for photography and the visual arts has led me to design interactive data visualizations to make complex systems legible. Data science, after all, is sometimes a little more art than science.</p>
            </Link>

            <Link to="/about" className="feature-card feature-card-global">
              <h3>Cross-Cultural Experience</h3>
              <p>Having taught executives in South America, run classrooms in the Himalayas, and conducted agricultural research in rural Africa, my work is thus imbued with an understanding that interaction with technology and information varies in each context.</p>
            </Link>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Systems That Work Across Contexts</h2>
            <p>Building AI for multilingual deployment and cross-cultural contexts.</p>
            <a href="mailto:seancafferty1@gmail.com" className="btn-primary-modern">
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
